export const getSession = (state) => state.session;